module.exports = __webpack_public_path__ + "assets/img/6.928ff612.jpg";